import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class VerificationPackagesFilterStateService {

  status: number = 0;

  reset(): void {
    this.resetStatusFilter();
  }

  resetStatusFilter(): void {
    this.status = 0;
  }
}